import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ModalModule} from 'ngx-bootstrap/modal';
import {JwBootstrapSwitchNg2Module} from 'jw-bootstrap-switch-ng2';

import {FooterComponent} from './footer/footer.component';
import {LoaderComponent} from './loader/loader.component';
import {NavbarComponent} from './navbar/navbar.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {PictureUploadComponent} from './picture-upload/picture-upload.component';
import {AuthNavbarComponent} from './auth-navbar/auth-navbar.component';
import {FixedPluginComponent} from './fixed-plugin/fixed-plugin.component';
import {AddressComponent} from './address/address.component';
import {NotesComponent} from './notes/notes.component';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown';
import {TranslateModule} from '@ngx-translate/core';
import {TranslationElementComponent} from './translation-element/translation-element.component';
import {MbDatatableComponent} from './mb-datatable/mb-datatable.component';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {SlimProductComponent} from './products/slim-product/slim-product.component';
import {
    LineOrBarChartWithTabsComponent
} from './charts/line-or-bar-chart-with-tabs/line-or-bar-chart-with-tabs.component';
import {MultiplePieChartComponent} from './charts/multiple-pie-chart/multiple-pie-chart.component';
import {DragAndDropComponent} from './drag-and-drop/drag-and-drop.component';
import {DirectivesModule} from '../directives/directives.module';
import {ExtraInfoComponent} from './products/extra-info/extra-info.component';
import {ConfirmModalComponent} from './confirm-modal/confirm-modal.component';
import {TooltipModule} from 'ngx-bootstrap';
import {CompanyShowComponent} from './company-show/company-show.component';
import {PlaceComponent} from './place/place.component';
import {NouisliderModule} from 'ng2-nouislider';
import {OnlyAddressComponent} from './address/only-address/only-address.component';
import {FeeOptionComponent} from './feeOption/fee-option/fee-option.component';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {AttachmentUploadComponent} from './attachment-upload/attachment-upload.component';
import {OrderNotificationComponent} from './socketNotification/order-notification/order-notification.component';
import {
    ReservationNotificationComponent
} from './socketNotification/reservation-notification/reservation-notification.component';
import {SlimRestaurantComponent} from './restaurants/slim-restaurant/slim-restaurant.component';
import {ShowPlaceComponent} from './place/show-place/show-place.component';
import {MbCalendarComponent} from './mbCalendar/mb-calendar/mb-calendar.component';
import {ShowAddressComponent} from './address/show-address/show-address.component';
import {OheShowComponent} from './opening-hours-element/ohe-show/ohe-show.component';
import {
    PageHeaderFromToFilterComponent
} from './page-header/page-header-from-to-filter/page-header-from-to-filter.component';
import {VideoPlayerComponent} from './video-player/video-player.component';
import {VgBufferingModule, VgControlsModule, VgOverlayPlayModule} from 'ngx-videogular';
import {AttachmentHandlerComponent} from './attachment-handler/attachment-handler.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {AttachmentElementComponent} from './products/attachment-element/attachment-element.component';
import {VideoPlayerModalComponent} from './video-player/video-player-modal/video-player-modal.component';
import {
    PageHeaderRestaurantFilterComponent
} from './page-header/page-header-restaurant-filter/page-header-restaurant-filter.component';
import {VoucherActionComponent} from './vouchers/voucher-action/voucher-action.component';
import {PushNotificationsModule} from 'ng-push-ivy';
import {RestaurantStatisticsComponent} from './restaurants/restaurant-statistic/restaurant-statistics.component';
import {LocalizedProductCardComponent} from './products/localized-product-card/localized-product-card.component';
import {BannerComponent} from './banner/banner.component';
import {ImgLayout33Component} from './banner/banner-img-layout/img-layout33/img-layout33.component';
import {ImgLayoutFourComponent} from './banner/banner-img-layout/img-layout-four/img-layout-four.component';
import {
    ImgLayoutVerticalThreeComponent
} from './banner/banner-img-layout/img-layout-vertical-three/img-layout-vertical-three.component';
import {ImgLayoutThreeComponent} from './banner/banner-img-layout/img-layout-three/img-layout-three.component';
import {ImgLayoutOneComponent} from './banner/banner-img-layout/img-layout-one/img-layout-one.component';
import {ImgLayout66Component} from './banner/banner-img-layout/img-layout66/img-layout66.component';
import {
    TitleDescAndLinkContentComponent
} from './banner/banner-content-layout/title-desc-and-link-content/title-desc-and-link-content.component';
import {TitleContentComponent} from './banner/banner-content-layout/title-content/title-content.component';
import {
    TitleAndLinkContentComponent
} from './banner/banner-content-layout/title-and-link-content/title-and-link-content.component';
import {
    TitleAndDescContentComponent
} from './banner/banner-content-layout/title-and-desc-content/title-and-desc-content.component';
import {
    BannerTranslateEditComponent
} from '../pages/translation/banner/modal/banner-translate-edit/banner-translate-edit.component';
import {LocalizationComponent} from './localization/localization.component';
import {QuillModule} from 'ngx-quill';
import {MakeryEventBaseComponent} from './makeryEvent/makery-event-base/makery-event-base.component';
import {MakeryEventComponent} from './makeryEvent/makery-event/makery-event.component';
import {MakeryEventProductComponent} from './makeryEvent/makery-event-product/makery-event-product.component';
import {SlimReservationInfoComponent} from './reservation/slim-reservation-info/slim-reservation-info.component';
import {
    AdditionalReservationDataComponent
} from './reservation/addational-reservation-data/additional-reservation-data.component';
import {BaseReservationDataComponent} from './reservation/base-reservation-data/base-reservation-data.component';
import {PageHeaderFromFilterComponent} from './page-header/page-header-from-filter/page-header-from-filter.component';
import {
    PageHeaderWithoutFilterComponent
} from './page-header/page-header-without-filter/page-header-without-filter.component';
import {ColorNotationComponent} from './color-notation/color-notation.component';
import {ShowVoucherComponent} from './vouchers/show-voucher/show-voucher.component';
import {VoucherDetailsComponent} from "./vouchers/voucher-details/voucher-details.component";
import {VoucherHistoryComponent} from "./vouchers/voucher-history/voucher-history.component";
import { LocalizationDataShowComponent } from './localization-data-show/localization-data-show.component';
import { TitleDescTwoLinkContentComponent } from './banner/banner-content-layout/title-desc-two-link-content/title-desc-two-link-content.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
        JwBootstrapSwitchNg2Module,
        CollapseModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        AngularMultiSelectModule,
        TranslateModule,
        NgxDatatableModule,
        DirectivesModule,
        TooltipModule.forRoot(),
        NouisliderModule,
        BsDatepickerModule,
        TabsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        VgControlsModule,
        DragDropModule,
        BsDatepickerModule.forRoot(),
        PushNotificationsModule,
        QuillModule,
    ],
    declarations: [
        LoaderComponent,
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        PictureUploadComponent,
        AuthNavbarComponent,
        FixedPluginComponent,
        AddressComponent,
        NotesComponent,
        TranslationElementComponent,
        MbDatatableComponent,
        SlimProductComponent,
        LineOrBarChartWithTabsComponent,
        MultiplePieChartComponent,
        DragAndDropComponent,
        ExtraInfoComponent,
        ConfirmModalComponent,
        CompanyShowComponent,
        PlaceComponent,
        OnlyAddressComponent,
        SlimRestaurantComponent,
        FeeOptionComponent,
        ShowPlaceComponent,
        AttachmentUploadComponent,
        OrderNotificationComponent,
        ReservationNotificationComponent,
        MbCalendarComponent,
        ShowAddressComponent,
        OheShowComponent,
        PageHeaderFromToFilterComponent,
        VideoPlayerComponent,
        AttachmentHandlerComponent,
        AttachmentElementComponent,
        VideoPlayerComponent,
        VideoPlayerModalComponent,
        PageHeaderRestaurantFilterComponent,
        VoucherActionComponent,
        RestaurantStatisticsComponent,
        LocalizedProductCardComponent,
        BannerComponent,
        ImgLayoutOneComponent,
        ImgLayout33Component,
        ImgLayout66Component,
        ImgLayoutThreeComponent,
        ImgLayoutFourComponent,
        ImgLayoutVerticalThreeComponent,
        TitleDescAndLinkContentComponent,
        TitleContentComponent,
        TitleAndLinkContentComponent,
        TitleAndDescContentComponent,
        BannerTranslateEditComponent,
        LocalizationComponent,
        MakeryEventBaseComponent,
        MakeryEventComponent,
        MakeryEventProductComponent,
        SlimReservationInfoComponent,
        AdditionalReservationDataComponent,
        BaseReservationDataComponent,
        PageHeaderFromFilterComponent,
        PageHeaderWithoutFilterComponent,
        ColorNotationComponent,
        ShowVoucherComponent, VoucherDetailsComponent, VoucherHistoryComponent, LocalizationDataShowComponent, TitleDescTwoLinkContentComponent
    ],
    exports: [
        LoaderComponent,
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        PictureUploadComponent,
        AuthNavbarComponent,
        FixedPluginComponent,
        AddressComponent,
        NotesComponent,
        TranslationElementComponent,
        MbDatatableComponent,
        SlimProductComponent,
        LineOrBarChartWithTabsComponent,
        MultiplePieChartComponent,
        DragAndDropComponent,
        ExtraInfoComponent,
        ConfirmModalComponent,
        CompanyShowComponent,
        PlaceComponent,
        OnlyAddressComponent,
        SlimRestaurantComponent,
        FeeOptionComponent,
        ShowPlaceComponent,
        AttachmentUploadComponent,
        OrderNotificationComponent,
        ReservationNotificationComponent,
        MbCalendarComponent,
        ShowAddressComponent,
        OheShowComponent,
        PageHeaderFromToFilterComponent,
        VideoPlayerComponent,
        AttachmentHandlerComponent,
        AttachmentElementComponent,
        VideoPlayerComponent,
        VideoPlayerModalComponent,
        PageHeaderRestaurantFilterComponent,
        VoucherActionComponent,
        RestaurantStatisticsComponent,
        LocalizedProductCardComponent,
        BannerComponent,
        ImgLayoutOneComponent,
        ImgLayout33Component,
        ImgLayout66Component,
        ImgLayoutThreeComponent,
        ImgLayoutFourComponent,
        ImgLayoutVerticalThreeComponent,
        TitleDescAndLinkContentComponent,
        TitleContentComponent,
        TitleAndLinkContentComponent,
        TitleAndDescContentComponent,
        LocalizationComponent,
        MakeryEventComponent,
        BaseReservationDataComponent,
        SlimReservationInfoComponent,
        PageHeaderFromFilterComponent,
        PageHeaderWithoutFilterComponent,
        ColorNotationComponent,
        ShowVoucherComponent, VoucherDetailsComponent, VoucherHistoryComponent, LocalizationDataShowComponent
    ]
})
export class ComponentsModule {
}
